import { render, staticRenderFns } from "./Model.vue?vue&type=template&id=4ad1e1c1"
import script from "./Model.vue?vue&type=script&lang=js"
export * from "./Model.vue?vue&type=script&lang=js"
import style0 from "./Model.vue?vue&type=style&index=0&id=4ad1e1c1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports